import router from "@/router";
import axios from "axios";
// import router from "@/router";
export default {
  namespaced: true,
  state: {
    authenticated: false,
    user: {},
    isPrescription:true,
    permissions:[],
    role:'',

  },
  getters: {
    authenticated(state) {
      return state.authenticated;
    },
    user(state) {
      return state.user;
    },
    isPrescription(state){
      return state.isPrescription;
    },
    permissions(state){
      return state.permissions;
    },

    role(state){
      return state.role;
    },
    
  },
  mutations: {
    SET_AUTHENTICATED(state, value) {
      state.authenticated = value;
    },
    SET_USER(state, value) {
      state.user = value;
    },
    SET_PRESCRIPTION(state, value) {
      state.isPrescription = value;
    },

    SET_PERMISSION(state, value) {
      state.permissions = value;
    },
 
    SET_ROLE(state, value) {
      state.role = value;
    },
  },
  actions: {
    login({ commit }, data) {
      // console.log(access_oken)
      axios
        // .get("https://anucios.jdesign.co.mz/Api/api/user", {
          .get("/starter/api/user", {
          headers: {
            Authorization: "Bearer " + data.access_token,
          },
        })
        .then(({ data }) => {
          commit("SET_USER", data.data.person);
          commit("SET_PERMISSION", data.data.person);
          commit("SET_ROLE", data.data.role[0]);
          commit("SET_AUTHENTICATED", true);
           router.push({path:'/'})
          console.log(data.data.permissions);
          if(data.data.role[0] == "Superadmin"){
            router.push({path:'/'})

          } 
  
        })
        .catch(() => {
          commit("SET_USER", {});
          commit("SET_AUTHENTICATED", false);
        });
    },

    updateUserData({commit}, data){
      commit("SET_USER", data);

    },

    prescription({commit}, data){

      commit("SET_PRESCRIPTION", data);
    },

    logout({ commit }) {
      commit("SET_USER", {});
      commit("SET_AUTHENTICATED", false);
    },
  },
};
